module.exports = __webpack_public_path__ + "assets/pdf/E13-cn-examining-airflow.86c0897f.pdf";